import type { SVGProps } from 'react';

const SvgCalanderMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 25 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M20.4619 6H4.46191V21H20.4619V6Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20.4619 6H4.46191V11H20.4619V6Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M7.46191 3V6' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M17.4619 3V6' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgCalanderMd;
